import React from "react"
import Input from "../contact/input"
import { useForm } from "react-hook-form"
export default function Enquire({ reff, book }) {
  let newDate = new Date()
  let nextDate = new Date(newDate)
  nextDate.setDate(newDate.getDate() + 5)
  let date = newDate.getDate()
  let nextdate = nextDate.getDate()
  let month = newDate.getMonth() + 1
  let nextmonth = nextDate.getMonth() + 1
  let year = newDate.getFullYear()

  const {
    register,
    handleSubmit,
    // formState: { errors },
    // control,
  } = useForm({
    defaultValues: {
      // beds: 4,
      checkIn: `${year}-${month < 10 ? `0${month}` : `${month}`}-${date}`,
      checkOut: `${year}-${
        nextmonth < 10 ? `0${month}` : `${nextmonth}`
      }-${nextdate}`,
    },
  })

  const Submit = data => {
    return console.log(data)
  }

  return (
    <div
      ref={reff}
      className="max-w-6xl mx-auto w-11/12 xl:w-full pb-12 md:pb-20 scroll-m-8"
    >
      <h3 className="text-xl text-teal-600 md:text-3xl pb-6 lg:pb-12 capitalize">
        Enquiry Form:
      </h3>
      <form
        onSubmit={handleSubmit(Submit)}
        className="grid md:grid-cols-2 gap-5 lg:gap-8"
      >
        <Input
          name="first"
          placeholder="Enter Your First Name"
          label="Your First Name* :"
          type="text"
          register={register}
        />
        <Input
          name="last"
          placeholder="Enter Your Last Name"
          label="Your Last Name* :"
          type="text"
          register={register}
        />
        <Input
          name="email"
          placeholder="Enter Your Email"
          label="Your Email* :"
          type="email"
          register={register}
        />
        <Input
          name="phone"
          placeholder="Enter Your Phone No."
          label="Your Phone* :"
          type="text"
          register={register}
        />
        {book && (
          <>
            <Input
              name="checkIn"
              placeholder="Check In"
              label="Start Date:"
              type="date"
              register={register}
            />
            <Input
              name="checkOut"
              placeholder="Check Out"
              label="End Date: "
              type="date"
              register={register}
            />
            <Input
              className="md:col-span-2"
              name="guests"
              placeholder="No. of Guests"
              label="Number of Guests:"
              type="number"
              register={register}
            />
          </>
        )}

        <Input
          className="md:col-span-2"
          TextArea
          name="message"
          label="Your Message* :"
          rows={12}
          register={register}
        />
        <div>
          <button className="px-6 py-3 uppercase tracking-[0.1em] rounded-xl text-sm bg-stone-700 text-white outline-none focus:outline-none">
            Enquire Now
          </button>
        </div>
      </form>
    </div>
  )
}
